import { createFileRoute } from '@tanstack/react-router';
import { OnboardProfilePage } from '#src/pages/OnboardingPage/index.ts';

export const Route = createFileRoute('/{-$locale}/onboarding/_wrapper/profile')({
  component: RouteComponent
});

function RouteComponent() {
  return <OnboardProfilePage />;
}
